import axios from 'axios';
import { API_ROUTES } from './constants';
import { apiClient } from './interceptor';
import { Toaster } from '../helpers/toaster';

export const getUserDetails = ({ id }) => {
  return apiClient({
    method: API_ROUTES.GET_USER_DETAILS.METHOD,
    url: `${API_ROUTES.GET_USER_DETAILS.URL}/${id}`,
  });
};
export const getAdminDetails = ({ id }) => {
  return apiClient({
    method: API_ROUTES.GET_ADMIN_DETAILS.METHOD,
    url: `${API_ROUTES.GET_ADMIN_DETAILS.URL}/${id}`,
  });
};

/**
 * One of the caller's own saved preferences.
 *
 * A user who has never saved is not an error -- the API answers with that
 * key's default -- so callers can use the result directly without a
 * "not found" branch.
 */
export const getUserPreference = ({ key }) => {
  return apiClient({
    method: API_ROUTES.GET_USER_PREFERENCE.METHOD,
    url: `${API_ROUTES.GET_USER_PREFERENCE.URL}/${key}`,
  });
};

/** Replaces the stored value outright; the caller sends the complete state. */
export const saveUserPreference = ({ key, value }) => {
  return apiClient({
    method: API_ROUTES.SAVE_USER_PREFERENCE.METHOD,
    url: `${API_ROUTES.SAVE_USER_PREFERENCE.URL}/${key}`,
    data: { value },
  });
};

export const uploadFileOnWasabi = ({ uploadUrl, file, cb = null }) => {
  let option = {
    headers: { 'x-amz-acl': 'public-read' },
    onUploadProgress: (progressEvent) => {
      if (!cb) return;
      const { loaded, total } = progressEvent;
      let percent = Math.floor((loaded * 100) / total);
      return cb(percent);
    },
  };
  try {
    return axios
      .put(uploadUrl, file, option)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        Toaster.error(error?.message || 'Something went wrong!');
        console.log('error-------->', error);
      });
  } catch (error) {
    return error.response;
  }
};
